import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, Button } from './ui';
import { ShieldCheck, Check, Zap } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 px-6 overflow-hidden bg-cream-light" data-id="element-180">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cream-dark/30 rounded-bl-full -z-10 blur-3xl opacity-50" data-id="element-181"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-sage-light/40 rounded-tr-full -z-10 blur-3xl opacity-50" data-id="element-182"></div>

      <div className="max-w-6xl mx-auto" data-id="element-183">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-10 lg:gap-x-16 lg:gap-y-6 items-center" data-id="element-184">
          {/* Block A: Badge + H1 (Mobile: 1st, Desktop: Top Left) */}
          <div className="lg:col-span-7 lg:col-start-1 lg:row-start-1 order-1 text-center lg:text-left" data-id="element-185">
            <FadeIn data-id="element-186">
              <span className="inline-block py-1 px-3 rounded-full bg-gold-light text-brown-light text-sm font-bold tracking-wider uppercase mb-6" data-id="element-187">
                Para mujeres 50+
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-2" data-id="element-188">
                21 Días Para Sentirte{' '}
                <span className="text-gold italic font-normal" data-id="element-189">
                  Como Tú Otra Vez
                </span>
              </h1>
            </FadeIn>
          </div>

          {/* Block B: Image (Mobile: 2nd, Desktop: Right Column) */}
          <div className="lg:col-span-5 lg:col-start-8 lg:row-start-1 lg:row-span-2 order-2 relative w-full max-w-lg mx-auto lg:max-w-none" data-id="element-190">
            <FadeIn delay={0.2} data-id="element-191">
              <div className="relative pt-8 shadow-brown/10" data-id="element-192">
                <motion.img src="https://cdn.magicpatterns.com/uploads/4cgxYYGjUuiR7n2Vk4vZWm/Imagen_LP.png" alt="Plan de 21 Días de Vitalidad Menopáusica, Portada del ebook" className="w-full h-auto object-contain bg-cream-light rounded-2xl shadow-2xl shadow-brown/10" animate={{
                y: [0, -24, 0]
              }} transition={{
                duration: 4.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-193" />
              </div>

              {/* Badge below image */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.6,
              type: 'spring'
            }} className="mt-6 mx-auto w-fit bg-white p-4 rounded-xl shadow-xl flex items-center gap-4 border border-cream-dark" data-id="element-194">
                <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center text-sage" data-id="element-195">
                  <Zap className="w-6 h-6" data-id="element-196" />
                </div>
                <div data-id="element-197">
                  <p className="text-sm font-bold text-brown" data-id="element-198">
                    Energía Estable
                  </p>
                  <p className="text-xs text-brown-light" data-id="element-199">En solo 21 días</p>
                </div>
              </motion.div>
            </FadeIn>
          </div>

          {/* Block C: Rest of content (Mobile: 3rd, Desktop: Bottom Left) */}
          <div className="lg:col-span-7 lg:col-start-1 lg:row-start-2 order-3 text-center lg:text-left" data-id="element-200">
            <FadeIn delay={0.1} data-id="element-201">
              <p className="text-lg md:text-xl text-brown font-medium mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-202">
                Si tienes más de 50 años y sientes que tu cuerpo dejó de ser tu
                aliado, esto fue escrito para ti. No es la edad. No es tu culpa.
                Es tu biología, y tiene solución en 21 días.
              </p>

              <div className="mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-203">
                <div className="space-y-3 text-base text-brown-light text-left inline-block lg:block" data-id="element-204">
                  <p className="flex items-start gap-3" data-id="element-205">
                    <Check className="w-5 h-5 text-sage mt-0.5 shrink-0" data-id="element-206" />
                    <span data-id="element-207">Te despiertas agotada aunque hayas dormido</span>
                  </p>
                  <p className="flex items-start gap-3" data-id="element-208">
                    <Check className="w-5 h-5 text-sage mt-0.5 shrink-0" data-id="element-209" />
                    <span data-id="element-210">La neblina mental no te deja ser tú</span>
                  </p>
                  <p className="flex items-start gap-3" data-id="element-211">
                    <Check className="w-5 h-5 text-sage mt-0.5 shrink-0" data-id="element-212" />
                    <span data-id="element-213">Tu energía desaparece antes del mediodía</span>
                  </p>
                </div>
              </div>

              <p className="text-sm md:text-base text-brown-light/80 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-214">
                Diseñado específicamente para el cuerpo femenino de 50+. Sin
                medicamentos. Sin dietas extremas. Sin rutinas imposibles.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-215">
              <div className="mb-8 lg:text-left text-center" data-id="element-216">
                <span className="text-sm text-brown-light uppercase tracking-wider font-bold" data-id="element-217">
                  Plan + 3 Bonos · Inversión única
                </span>
                <div className="flex items-baseline justify-center lg:justify-start gap-3 mt-1" data-id="element-218">
                  <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-219">
                    $47
                  </span>
                  <span className="text-5xl font-bold text-coral" data-id="element-220">$17</span>
                  <span className="text-2xl text-brown-light font-normal" data-id="element-221">
                    USD
                  </span>
                </div>
                <span className="inline-flex items-center gap-1 mt-2 bg-sage-light text-sage text-sm font-bold px-3 py-1 rounded-full" data-id="element-222">
                  <Zap className="w-3.5 h-3.5" data-id="element-223" />
                  Ahorra más del 60%
                </span>
              </div>

              <div className="mb-8 flex items-start gap-3 bg-sage-light/40 border border-sage/20 rounded-2xl p-4 max-w-md mx-auto lg:mx-0 text-left" data-id="element-224">
                <ShieldCheck className="w-6 h-6 text-sage shrink-0 mt-0.5" data-id="element-225" />
                <p className="text-sm text-brown-light leading-relaxed" data-id="element-226">
                  <span className="font-bold text-brown" data-id="element-227">
                    Garantía de 7 días sin riesgo.
                  </span>{' '}
                  Si no sientes la diferencia te devolvemos cada centavo. Sin
                  preguntas.
                </p>
              </div>

              <Button className="mx-auto lg:mx-0" href="https://pay.hotmart.com/W105376697A?checkoutMode=10" onClick={() => {
              try {
                const fbq = (window as any).fbq;
                if (fbq) fbq('track', 'AddToCart', {
                  currency: 'USD',
                  value: 17,
                  content_name: 'Plan de 21 Días de Vitalidad Menopáusica',
                  content_type: 'product'
                });
              } catch (e) {}
            }} data-id="element-228">
                ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
              </Button>

              <p className="mt-6 text-base md:text-lg font-bold text-center lg:text-left text-brown" data-id="element-229">
                Acceso instantáneo tras la compra. Tu nueva vitalidad comienza
                mañana mismo.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};